import React, { createContext, useState, useContext, useEffect } from "react";
import { authAPI } from "../services/api";
import toast from "react-hot-toast";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedUser = localStorage.getItem("user");

    if (token && storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        console.error("Failed to parse user:", error);
        localStorage.removeItem("token");
        localStorage.removeItem("user");
      }
    }

    setLoading(false);
  }, []);

  const login = async (email, password, rememberMe = false) => {
    try {
      console.log("Attempting login with:", email);
      const response = await authAPI.login({ email, password });
      console.log("Login response:", response);

      if (response.data.success) {
        const { token, user } = response.data;

        // บันทึก token ลง localStorage เสมอ (จำเป็น)
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(user));

        // ถ้าเลือก Remember Me ให้บันทึก email ไว้
        if (rememberMe) {
          localStorage.setItem("rememberedEmail", email);
        } else {
          localStorage.removeItem("rememberedEmail");
        }

        setUser(user);

        toast.success(`ยินดีต้อนรับ ${user.mem_fname} ${user.mem_sname}`);
        return true;
      } else {
        toast.error(response.data.message || "เข้าสู่ระบบล้มเหลว");
        return false;
      }
    } catch (error) {
      console.error("Login error:", error);
      if (error.response) {
        console.error("Error response:", error.response.data);
        toast.error(error.response.data?.message || "เข้าสู่ระบบล้มเหลว");
      } else if (error.request) {
        toast.error("ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์");
      } else {
        toast.error("เกิดข้อผิดพลาด กรุณาลองอีกครั้ง");
      }
      return false;
    }
  };

  const register = async (userData) => {
    try {
      const response = await authAPI.register(userData);

      if (response.data.success) {
        toast.success("ลงทะเบียนสำเร็จ กรุณาเข้าสู่ระบบ");
        return true;
      } else {
        toast.error(response.data.message || "ลงทะเบียนล้มเหลว");
        return false;
      }
    } catch (error) {
      console.error("Registration error:", error);
      if (error.response) {
        toast.error(error.response.data?.message || "ลงทะเบียนล้มเหลว");
      } else {
        toast.error("เกิดข้อผิดพลาด กรุณาลองอีกครั้ง");
      }
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    toast.success("ออกจากระบบสำเร็จ");
  };

  const value = {
    user,
    loading,
    login,
    register,
    logout,
    isAuthenticated: !!user,
    isAdmin: user?.level === "1",
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
